import { BaseModel } from './base';

export class ApprovalType extends BaseModel {
  approvaltypeName: string;
  SubscriberId: string;
  SiteId: string;
  dateCreated: string;
  dateModified: string;
}
